import recimetApi from './recimetApi';

export const productosHelper = async () => {
  const urlAxiosRequest = 'productos';
  try {
    await recimetApi
      .get(urlAxiosRequest, {
        headers: {
          Authorization: JSON.parse(sessionStorage.getItem('session') || localStorage.getItem('session')).jwt,
        },
      })
      .then((response) => {
        const tablaProducto = response.data;
        const filter = (event) => {
          return event.Activo === 'S';
        };
        const data = tablaProducto.filter(filter);
        if (data.length !== 0) {
          sessionStorage.setItem('tablaProductos', JSON.stringify(data));
        }
      });
  } catch (error) {
    throw error;
  }
};
